export default "__VITE_ASSET__B_ovZSyV__"